<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading...">
  </mat-progress-bar>
</section>

<section *ngIf="downloading">
  <h2>Downloading...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="downloading...">
  </mat-progress-bar>
</section>

<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>

<section [hidden]="loading">
  <mat-card >
    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
      <strong class="noMarginHeader">Results ({{resultSize}}) </strong>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <mat-form-field style="width:200px;">
        <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
      </mat-form-field>
      <a (click)="load()"><mat-icon>refresh</mat-icon> </a>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;       
        <button mat-raised-button [disabled]="processing || loading ||  authService.isReadOnly() || voucherId == 0" color="primary" (click)="generateCOC()" >Generate Chain of Custody Letter</button>
      </span>
      <br />
      <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
        style="overflow-x: auto;">
        <mat-row>Results ({{resultSize}})</mat-row>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Letter Id</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span *ngIf="result.id > 0">{{result.id}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="letterType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Letter Type</mat-header-cell>
          <mat-cell *matCellDef="let result">
            {{result.letterType}}
            <small *ngIf="result.year > 0 && result.letterType == voucherService.voucherCOCLetterType && result.quarter > 0">              
              &nbsp;{{result.year}} Q{{result.quarter}}
            </small>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="complete">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">Complete</mat-header-cell>
          <mat-cell *matCellDef="let result" fxFlex="20">
            <span *ngIf="!result.complete" class="text-red-400">
              <em *ngIf="result.applicationType == voucherService.wildfireVoucherType">{{result.incompleteDetails}}</em>
              <em *ngIf="result.applicationType == voucherService.lubgwmaTestingVoucherType && result.letterType != voucherService.exceedanceLetterType">{{result.incompleteDetails}}</em>
              <em *ngIf="result.applicationType == voucherService.lubgwmaTestingVoucherType && result.letterType == voucherService.exceedanceLetterType">Missing Treatment letter</em>              
            </span>
            <span *ngIf="result.complete" class="text-green-400">Yes</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sampleId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Id</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span *ngIf="result.sampleId != null && result.sampleId > 0">{{result.sampleId}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="analyte">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Analyte</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span *ngIf="result.parameterResultId != null && result.parameterResultId > 0">{{result.analyte}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="result">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Result</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span *ngIf="result.parameterResultId != null && result.parameterResultId > 0">{{result.result}}
              {{result.unit}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sentDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Sent Date</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span *ngIf="result.contactType !=null && result.contactType.length > 0 && result.letterType != voucherService.voucherCOCLetterType">{{result.contactDate}} via {{result.contactType}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions"><mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <!-- Generate -->
            <span *ngIf="result.needsLetterGenerated && result.letterType != voucherService.notEligible && !authService.isReadOnly()"><mat-icon matTooltip="Generate Letter"
                (click)="generate(result.letterType, result.parameterResultId, result.sampleId, result.id, result.applicationType)">note_add</mat-icon>&nbsp;&nbsp;</span>

            <span *ngIf="result.needsLetterGenerated && result.letterType == voucherService.notEligible && !authService.isReadOnly()"><mat-icon matTooltip="Generate Not Eligible Letter"
                (click)="generateNotEligible(result.letterType, result.applicationId, result.applicationType)">note_add</mat-icon>&nbsp;
            </span>

            <!-- Download -->
            <span *ngIf="(result.complete || result.canDownload) && result.letterType != voucherService.notEligible"><mat-icon
                matTooltip="Download Letter"
                (click)="downloadVoucherLetter(result.id, result.voucherIdentifier, result.letterType, result.parameterResultId)">cloud_download</mat-icon>&nbsp;&nbsp;</span>
              
            <span *ngIf="(result.complete || result.canDownload) && result.letterType == voucherService.notEligible"><mat-icon
              matTooltip="Download Letter"
              (click)="downloadApplicationLetter(result.id,  result.letterType)">cloud_download</mat-icon>&nbsp;&nbsp;</span>

            <!-- Attach -->
            <span *ngIf="result.missingAttachment  && result.letterType != voucherService.notEligible && !authService.isReadOnly()"><mat-icon matTooltip="Attach Letter"
                (click)="attachVoucherLetter(result.id, result.voucherId, result.letterType, result.sampleId, result.parameterResultId)">attach_file</mat-icon>&nbsp;&nbsp;</span>
            
            <span *ngIf="result.missingAttachment && result.letterType == voucherService.notEligible && !authService.isReadOnly()"><mat-icon matTooltip="Attach Not Eligible Letter"
                  (click)="attachApplicationLetter(result.applicationId, result.letterType)">attach_file</mat-icon>&nbsp;
            </span>

            <!-- Missing Sent -->
            <span *ngIf="(result.complete || result.missingLetterSentInfo) && result.letterType != voucherService.voucherCOCLetterType && !authService.isReadOnly()"><mat-icon
                matTooltip="Update voucher Letter Sent Info"
                (click)="sendLetter(result.id)">beenhere</mat-icon>&nbsp;&nbsp;</span>

            <!-- Delete -->
            <span *ngIf="result.id > 0 && result.letterType != voucherService.notEligible && !authService.isReadOnly()"><mat-icon matTooltip="Delete Voucher Letter"
                (click)="deleteVoucherLetter(result.id)">delete</mat-icon> &nbsp;</span>

            <span *ngIf="result.id > 0 && result.letterType == voucherService.notEligible && !authService.isReadOnly()"><mat-icon matTooltip="Delete Application Letter"
                (click)="deleteApplicationLetter(result.id)">delete</mat-icon> &nbsp;</span>

          </mat-cell>
        </ng-container>

      </mat-table>
      <br />
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator"
        showFirstLastButtons></mat-paginator>
    </div>
  </mat-card>
</section>